import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { ActionIcon, polymorphicFactory, useProps } from '@coveord/plasma-mantine';
import { useTopBarContext } from './TopBarContext.js';
var defaultProps = {
    size: 'lg'
};
export var TopBarAction = polymorphicFactory(function(_props) {
    var ctx = useTopBarContext();
    var _useProps = useProps('TopBarAction', defaultProps, _props), children = _useProps.children, ref = _useProps.ref, others = _object_without_properties(_useProps, [
        "children",
        "ref"
    ]);
    return /*#__PURE__*/ _jsx(ActionIcon.Quaternary, _object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles('action'), others), {
        children: children
    }));
});
TopBarAction.displayName = 'TopBar.Action';

//# sourceMappingURL=TopBarAction.js.map